import React, { useCallback, useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from '../api/axios';

interface HouseSummary {
  name: string;
}

const HousePageBackLink: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const [houseName, setHouseName] = useState<string>('');

  const fetchHouseName = useCallback(async () => {
    if (!id) {
      return;
    }

    try {
      const response = await axios.get<HouseSummary>(`/houses/${id}`);
      setHouseName(response.data.name);
    } catch {
      setHouseName('');
    }
  }, [id]);

  useEffect(() => {
    fetchHouseName();
  }, [fetchHouseName]);

  return (
    <Button
      component={RouterLink}
      to={id ? `/houses/${id}` : '/'}
      startIcon={<ArrowBack />}
      sx={{ mb: 2.5 }}
    >
      {houseName || t('houseDetail.backToHouse')}
    </Button>
  );
};

export default HousePageBackLink;